import React, { useLayoutEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../styles/Products.css";

const Products = () => {
  const carouselContainer = useRef(null);
  const [slidesToShow, setSlidesToShow] = useState(1);

  useLayoutEffect(() => {
    const container = carouselContainer.current;
    const updateSlides = () => {
      setSlidesToShow(Math.max(1, Math.min(4, Math.floor(container.clientWidth / 280))));
    };

    updateSlides();
    window.addEventListener("resize", updateSlides);
    const observer = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(updateSlides)
      : null;
    observer?.observe(container);

    return () => {
      window.removeEventListener("resize", updateSlides);
      observer?.disconnect();
    };
  }, []);

  const products = [
    { name: "AI-Nutri Tablets", image: `${process.env.PUBLIC_URL}/images/AI_NUTRI_TABLETS.jpeg` },
    { name: "AI-Nutri Syrup", image: `${process.env.PUBLIC_URL}/images/AI_NUTRI_SYRUP.jpeg` },
    { name: "AI-Nutri Drops", image: `${process.env.PUBLIC_URL}/images/AI_NUTRI_DROPS.jpeg` },
    { name: "AI-D3 Nano Shots", image: `${process.env.PUBLIC_URL}/images/AI_D3.png` },
    { name: "AI-FX Suspension", image: `${process.env.PUBLIC_URL}/images/AI_FX.jpeg` },
    { name: "AI-Q10 Tablets", image: `${process.env.PUBLIC_URL}/images/AI_Q10.png` },
    { name: "Pantofril-D Capsules", image: `${process.env.PUBLIC_URL}/images/PANTOFRIL_D.jpeg` },
    { name: "Zenzical XT Tablets", image: `${process.env.PUBLIC_URL}/images/ZENZICAL_XT.png` },
    { name: "Zenzipro Capsules", image: `${process.env.PUBLIC_URL}/images/ZENZIPRO_CAPSULES.jpeg` },
    { name: "Zenzipro Sachet", image: `${process.env.PUBLIC_URL}/images/ZENZIPRO_SACHET.png` },
    { name: "Zenzipro Syrup", image: `${process.env.PUBLIC_URL}/images/ZENZIPRO_SYRUP.png` },
    { name: "Ostofril Plus Tablets", image: `${process.env.PUBLIC_URL}/images/OSTOFRIL_PLUS_TABLETS.jpeg` },
    { name: "Ostofril Sachet", image: `${process.env.PUBLIC_URL}/images/OSTOFRIL_SACHET.png` },
    { name: "Vanofril-DP Tablets", image: `${process.env.PUBLIC_URL}/images/VANOFRIL_DP.png` },
    { name: "AI-Fresh Mouth Wash", image: `${process.env.PUBLIC_URL}/images/AI_FRESH.jpeg` },
    { name: "AI-Koff-LS Syrup", image: `${process.env.PUBLIC_URL}/images/AI_KOFF_LS.png` },
    { name: "AI-Koff-DX Syrup", image: `${process.env.PUBLIC_URL}/images/AI_KOFF_DX.png` },
    { name: "Zencumin Capsules", image: `${process.env.PUBLIC_URL}/images/ZENCUMIN.png` }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnHover: true,
    pauseOnFocus: true,
  };

  return (
    <section className="products" id="products">
      <h1 className="products-title">Our Products</h1>
      <div ref={carouselContainer}>
        <Slider {...settings} className="products-slider">
          {products.map((product, index) => (
            <div key={index}>
              <div className="product-card">
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
                <h1 className="product-name">{product.name}</h1>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Products;